<template>
    <section class="container mt-5 mb-5">
        <div class="set-password__container mt-5 mb-5" v-if="emailReminded === false">
            <h3 class="title-content">{{ $t('GENERATE_ACTIVATION_LINK') }}</h3>
            <p class="set-password__heading">{{ $t('INSERT_EMAIL_GIVEN_DURING_REGISTRATION') }}</p>
            <form class="form--main mt-5 mb-5">
                <div class="form-group">
                    <div :class="{ control: true }">
                        <p v-if="errors.has('email')" class="validate-danger">
                            <img src="./../../../assets/images/icons/excl-red.svg" />
                            {{ $t('COMPLETE_FIELDS_CORRECTLY') }}
                        </p>
                        <input
                            id="loginEmail"
                            ref="loginEmail"
                            v-validate="{ required: true, regex: emailRegex }"
                            data-vv-validate-on="none"
                            :class="{ validate: errors.any() }"
                            class="text-input -white-input-border"
                            name="email"
                            v-model="email"
                            :placeholder="$t('EMAIL_ADDRESS')"
                            type="text"
                        />
                    </div>
                </div>
                <button class="app-btn app-btn--big app-btn-primary" @click.prevent="remindPassword">
                    {{ $t('SEND_WITHOUT_DOT') }}
                </button>
            </form>
        </div>

        <div class="text-xs-center mt-5 mb-5" v-else>
            <p class="forgot-password-sent">
                <img src="./../../../assets/images/icons/check-red.svg" />
                {{ $t('ACTIVATION_LINK_SENT_AGAIN') }}
            </p>

            <button class="app-btn app-btn--big app-btn-primary" @click.prevent="goToLogin">
                {{ $t('GO_BACK_TO_LOGIN_PAGE') }}
            </button>
        </div>
    </section>
</template>

<script>
import { config } from './../../../main';
import { sha256 } from 'js-sha256';

export default {
    data() {
        return {
            email: '',
            emailReminded: false,
            emailRegex: config.emailRegex,
        };
    },
    methods: {
        remindPassword() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$http.get(`${config.authUrl}/public/${sha256(this.email.toLowerCase())}/localServer`).then(
                        data => {
                            this.$http
                                .post(data.body.localServerUrl + '/user/public/registration/sendActivationCode/', {
                                    email: this.email,
                                })
                                .then(() => (this.emailReminded = true));
                        },
                        () => (this.emailReminded = true),
                    );
                }
            });
        },
        goToLogin() {
            this.$router.push('logowanie');
        },
    },
};
</script>

<style lang="scss">
.set-password__container {
    width: 70%;
    max-width: 815px;
    margin-left: auto;
    margin-right: auto;
}

.set-password__heading {
    color: #706c69;
    font-weight: 500;
    display: block;
    font-size: 18px;
}

.forgot-password-sent {
    position: relative;
    padding-left: 60px;
    color: #333333;
    font-size: 18px;
    line-height: 20px;
    font-weight: 800;
    width: 400px;
    margin: 30px auto;
    text-align: left;

    img {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// send-activation-link-again.vue?9a9b46b0